<template>
  <div id="footer">
    <img class="logo-pisco" src="@/assets/LogoPiscoBlack.svg" alt="Pisco Sistemas" />
  </div>
</template>

<script>
export default {
  name: "PageFooter",
};
</script>

<style lang="scss" scoped>
#footer {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 64px;
  flex: 0 0 auto;
  background-color: #e4e4e4;

  .logo-pisco {
    height: 36px;
  }
}
</style>
